import "../../../assets/css/AddCatalogs.css";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useEffect, useState, useLayoutEffect } from "react";
import Axios from "../../../utils/axios";
import Input from "../../../components/Atomos/Inputs/Input";
import SwitchToogle from "../../../components/Atomos/Switch-Toogle/Switch";
import GoBack from "../../../components/Moleculas/GoBack";
import ButtonsCrud from "../../../components/Catalogs/ButtonsCrud";
import DDMultiple, {
  Option,
} from "../../../components/Atomos/DropDown/DDMultiple";
import CatalogTitle from "../../../components/Moleculas/Catalog Text/CatalogTitle";
import CatalogSubTitle from "../../../components/Moleculas/Catalog Text/CatalogSubTitle";
import PracticeIndustriesMapping from "../../../components/MappingAOP/AOPMapping";
import { IAreaOfPractice } from "../../../interfaces/models/IAreaOfPractice";
import { UseFirmList } from "../../../hooks/Catalogs/useFirm";
import { UsePracticeIndustryList } from "../../../hooks/Catalogs/usePracticeIndustry";
import { getOfficeByFirm } from "../../../Services/Office";
import { getCurrentTimestamp, getNameById } from "../../../utils/functions";
import { IPracticeIndustry } from "../../../interfaces/models/IPracticeIndustry";
import { countPersonsByOffices } from "../../../Services/Person";
import { useSelector } from "react-redux";
import { Appstore } from "../../../redux/store";
import BackgroundComponent from "../../../components/Layout/BackgroundProfile/BackgroundProfile";
import ProfileViewModeBg from "../../../assets/images&icons/profileViewMode.jpeg";
const WSGDots = require("../../../assets/images&icons/WSGDots.svg");
const axios = new Axios();
interface iCatalogProps {
  mode: "add" | "edit";
}

interface IErrorState {
  nameAlreadyExists: boolean;
  nameRequired: boolean;
  firmsRequired: boolean;
  officesRequired: boolean;
  firmsErrorMessage: string;
  officesErrorMessage: string;
  lenErr?: boolean;
  practiceIndustriesRequired?: boolean;
}

const initialErrorState: IErrorState = {
  nameAlreadyExists: false,
  nameRequired: false,
  firmsRequired: false,
  officesRequired: false,
  firmsErrorMessage: "",
  officesErrorMessage: "",
  lenErr: false,
  practiceIndustriesRequired: false,
};
interface FirmOfficePair {
  firm: Option | null;
  offices: Option[];
  formattedOffices?: Option[];
  error: boolean;
}

const AddAOPs: React.FC<iCatalogProps> = (props) => {
  const manageFirm = useSelector((state: Appstore) => state.manageFirm);
  const { state } = useLocation();
  const location = useLocation();
  const navigate = useNavigate();
  const { mode } = props;
  const isEditMode = props.mode === "edit";
  const [isIgnored, setIsIgnored] = useState(false);
  const [errorState, setErrorState] = useState<IErrorState>(initialErrorState);
  const [inputValue, setInputValue] = useState("");
  const { id } = useParams();
  const [isModified, setIsModified] = useState(true);
  const [firmsOfficesPairs, setFirmsOfficesPairs] = useState<FirmOfficePair[]>([
    {
      firm: null,
      offices: [],
      error: false,
    },
  ]);
  const [officeData, setOfficeData] = useState<any[]>([]);
  const [selectedOffice, setSelectedOffice] = useState<any[]>([]);

  const { firmData } = UseFirmList();
  const { practiceIndustryData } = UsePracticeIndustryList();
  const [currentPracticeIndustries, setCurrentPracticeIndustries] = useState<
    any[]
  >([]);

  const attemptSaveOrUpdate = async (action: string) => {
    await updateAop();
  };

  const fetchOffices = async (firmId?: string) => {
    try {
      if (!firmId) {
        return;
      }
      const offices = await getOfficeByFirm(firmId);
      const _officeData = offices.map((o: any) => ({ id: o.id, name: o.name }));
      setOfficeData(_officeData);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!firmData.length) {
      return;
    }

    fetchOffices(manageFirm.selectedFirm?.id);
  }, [firmData, manageFirm.selectedFirm?.id]);

  const updateAop = async () => {
    try {
      const firms = [{
        id: manageFirm.selectedFirm?.id,
        office: selectedOffice.map(o => o.id)
      }]
      const practiceIndustryIds = currentPracticeIndustries
        .filter((cp) => cp.isChecked)
        .map((cp) => cp.id);
      const practiceIndustryNames = practiceIndustryIds
        .map((p) => getNameById(p, practiceIndustryData))
        ?.join(", ");
      const professionals = await countProfessionals();
      const newAOP: IAreaOfPractice = {
        ...state,
        name: inputValue?.trim() !== "" ? inputValue : state?.name,
        isIgnored: isIgnored,
        firms,
        firmNames: [manageFirm.selectedFirm?.name],
        practiceIndustries: practiceIndustryIds,
        practiceIndustryNames,
        professionals,
        createdDate: state?.createdDate ?? getCurrentTimestamp(),
      };
      mode === "edit"
        ? await axios.Put("/areaOfPractice", newAOP)
        : await axios.Post("/areaOfPractice", newAOP);
      navigate(-1);
    } catch (error) {
      console.error(error);
    }
  };

  const countProfessionals = async () => {
    try {
      const officeIds = firmsOfficesPairs.map((f) =>
        f.offices?.map((o) => o.id)
      );

      if (officeIds.length === 0) {
        return 0;
      }

      const flattenedOfficeIds = officeIds
        .flat()
        .filter((id): id is string => id !== undefined);
      const [professionalsNumber] =
        await countPersonsByOffices(flattenedOfficeIds);
      return professionalsNumber;
    } catch (error) {
      console.error(error);
      return 0;
    }
  };

  useEffect(() => {
    setErrorState(initialErrorState);
  }, [practiceIndustryData, isIgnored]);

  useLayoutEffect(() => {
    loadOfficesForFirms();
    loadCurrentPI();
  }, [practiceIndustryData]);

  const loadOfficesForFirms = async () => {
    if (!state?.firms) {
      return;
    }

    const offices = await Promise.all(
      state.firms.map(async (firm: any) => {
        return (await getOfficeByFirm(firm.id)).map((o: any) => ({
          id: o.id,
          name: o.name,
        }));
      })
    );
    setOfficeData(offices);

    const _firmsOfficesPairs = state.firms?.map((firm: any, index: any) => {
      return {
        firm: { id: firm.id, name: getNameById(firm.id, firmData).join() },
        error: false,
        offices: firm.office?.map((o: any) =>
          offices[index].find((office: any) => office.id === o)
        ),
      };
    });

    if (_firmsOfficesPairs.length) {
      setFirmsOfficesPairs(_firmsOfficesPairs);
    }
  };

  const loadCurrentPI = async () => {
    const blankPI: IPracticeIndustry[] = practiceIndustryData.map((p) => ({
      id: p.id,
      name: p.name,
      icon: p.icon,
      createdAt: p.createdAt,
    }));
    setCurrentPracticeIndustries(blankPI);
  };

  const handleCheckboxChange = (industryId: string) => {
    const updatedIndustries = currentPracticeIndustries.map((industry) => {
      if (industry.id === industryId) {
        return { ...industry, isChecked: !industry.isChecked };
      }
      return industry;
    });
    setCurrentPracticeIndustries(updatedIndustries);
  };

  const inputOnchange = (e: any) => {
    setInputValue(e.target.value);
    const nameError = inputValue?.trim() === "";
    setErrorState((prevState) => ({
      ...prevState,
      nameRequired: nameError,
      nameAlreadyExists: false,
    }));
    setIsModified(true);
    setErrorState(initialErrorState);
  };

  const isButtonDisabled = () => {
    return !isModified || Object.values(errorState)?.some((error) => error);
  };

  const handleDelete = async (id: string) => {
    try {
      const deleteAopResponse = await axios.Delete(`/AreaOfPractice`, id);
      if (deleteAopResponse.status === 200) {
        navigate(-1);
      } else {
        console.error("Error al eliminar el AOP:", deleteAopResponse.data);
      }
    } catch (error) {
      console.error("Error durante la eliminación:", error);
    }
  };

  return (
    <>
      <BackgroundComponent image={ProfileViewModeBg} />
      <div className="bg-gray-100 min-h-screen text-left px-4 py-7 items-start flex flex-col gap-[1.5rem] md:py-8 md:px-6 lg:py-10 lg:px-10 lg:gap-[2.5rem]">
        <div className="flex flex-col items-start gap-5 self-stretch">
          <div className="w-full relative z-10 flex gap-5 md:gap-6 lg:gap-7 self-stretch !p-0 flex-col ">
            <CatalogTitle
              title={`${props.mode === "add" ? "New Area Of Practice" : `Edit ${state?.name}`}`}
              className="text-white"
            >
              <div
                className="self-stretch flex-1 flex h-[50px]"
                style={{
                  backgroundImage: `url(${WSGDots.default})`,
                }}
              ></div>
              <GoBack className="!text-white" />
            </CatalogTitle>
            <article className="articleSection">
              {props.mode === "add" && (
                <>
                  <section className="formsectionNTitle">
                    <CatalogSubTitle
                      className="text-accent-Default-dark"
                      title="AOP Information"
                    />
                  </section>
                  <div className="flex flex-col items-start gap-5 self-stretch lg:flex-row">
                    <div className="flex items-start gap-5 self-stretch w-full">
                      <Input
                        isWfull={true}
                        value={inputValue}
                        onChange={inputOnchange}
                        name="Name"
                        title="Name"
                        required={true}
                        error={
                          errorState.nameRequired ||
                          errorState.nameAlreadyExists
                        }
                        errorMsj={
                          errorState.nameRequired
                            ? "Name is required."
                            : errorState.nameAlreadyExists
                              ? "This value is already registered in the DB. Please input a different/new one."
                              : ""
                        }
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="flex flex-col items-start gap-6 self-stretch">
                <section className="formsectionNTitle">
                  <CatalogSubTitle
                    className="text-accent-Default-dark"
                    title="Catalog List Relationships"
                  />
                </section>
                <div className="flex flex-col items-start gap-5 self-stretch">
                  <div className="w-full">
                    <DDMultiple
                      required
                      title="Offices"
                      objects={officeData}
                      selectedObjst={selectedOffice}
                      seter={setSelectedOffice}
                      error={errorState.officesRequired}
                      errorMessage={
                        errorState.officesRequired
                          ? errorState.officesErrorMessage
                          : undefined
                      }
                    />
                  </div>
                </div>
              </div>
              <section className="formsectionNTitle">
                <div className="flex flex-col gap-[.625rem]">
                  <CatalogSubTitle
                    className="text-accent-Default-dark"
                    title="Areas Of Practice Mapping"
                  />
                  {errorState.practiceIndustriesRequired ? (
                    <span
                      className={`flex flex-wrap items-center text-sm font-medium text-feedback-error`}
                    >
                      Map or Ignore AOP
                    </span>
                  ) : null}
                </div>
              </section>
              <div className="flex flex-col w-full gap-5 md:flex-row">
                <div className="flex gap-[.625rem] items-center self-stretch md:flex-col md:items-center md:w-max">
                  <label className="text-[#474F56] whitespace-nowrap text-base leading-[1.125rem] lg:text-[1.125rem] lg:leading-[1.125rem] roboto_font">
                    Ignore AOP
                  </label>
                  <SwitchToogle
                    checked={isIgnored}
                    seter={() => setIsIgnored(!isIgnored)}
                    small={true}
                    centered
                  />
                </div>
                {isEditMode && (
                  <div className="flex items-start gap-5 self-stretch w-full">
                    <Input
                      isWfull={true}
                      value={inputValue}
                      onChange={inputOnchange}
                      name="Name"
                      title="Rename AOP"
                      required={false}
                      error={
                        errorState.nameRequired || errorState.nameAlreadyExists
                      }
                      errorMsj={
                        errorState.nameRequired
                          ? "Name is required."
                          : errorState.nameAlreadyExists
                            ? "This value is already registered in the DB. Please input a different/new one."
                            : ""
                      }
                    />
                  </div>
                )}
              </div>
              <PracticeIndustriesMapping
                practiceIndustries={currentPracticeIndustries}
                onIndustryChange={handleCheckboxChange}
              />
              <div className="flex gap-[.625rem] justify-end"></div>
              <ButtonsCrud
                Catalog="AreaOfPractice"
                mode={props.mode}
                disabled={isButtonDisabled()}
                id={id ? id : ""}
                actionButton={attemptSaveOrUpdate}
                onDelete={handleDelete}
              />
            </article>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAOPs;
